import {createGlobalStyle} from 'styled-components';
import img from './lain1.jpg';

const PracticeFormStyle = createGlobalStyle`
body {
    background: url(${img}) no-repeat center center fixed;
        background-size:  cover;
        font-family: Arial, sans-serif;
        background-color: #f5f5f5;
        color: #333;
        font-size: 18px;
        margin: 0;
        padding: 0;
        text-align: fit;
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }
  
    h1 {
    
        color: white;
        font-size: 50px;
        font-weight: bold;
        margin-top: 50px;
        text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
    }
  
  h2 {
    
        color: white;
        font-size: 24px;
        font-weight: bold;
        margin-top: 50px;
        text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
    }
  
    label {
        display: block;
        color: white;
        text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
        font-size: 20px;
        font-weight: bold;
        margin: 30px 0 10px;
        text-align: center;
    }
  
    input[type="radio"] {
        margin: 10px;
        padding: 10px;
        border-radius: 50%;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease-in-out;
    }
  
  label input[type="radio"]:checked + span {
  text-decoration: underline;
  color:pink;
  transition: all 0.3s ease-in-out;
  transform: scale(1.1);
  animation: electric 0.8s infinite;
  
    }
  
    input[type="radio"]:hover {
        transform: scale(1.1);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
        animation: electric 0.8s infinite;
    }
  
  
  
    input[type="number"] {
        display: block;
        height: auto;
        width: 60px;
        margin: 10px auto;
        padding: 10px;
        border: none;
        border-radius: 5px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease-in-out;
    }
  
    input[type="number"]:hover {
        transform: scale(1.1);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
    }
  
    input[type="submit"] {
        display: block;
        margin: 30px auto;
        padding: 10px 20px;
        background-color: #333;
        color: #fff;
        border: none;
        border-radius: 5px;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease-in-out;
  
    }
  
    input[type="submit"]:hover {
        transform: scale(1.1);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  animation: electric 0.8s infinite;
    }


  main {
    flex-grow: 1;
  }
 
  header {
    background-color: #333;
   padding: 20px;
    
    padding-bottom: 30px;
    margin: 0 auto;
        }


  nav ul {
            margin: 0;
            padding: 0;
            list-style: none;
      }
  
    nav ul li {
       display: inline-block;
       margin-right: 20px;
    }
  
    nav ul li:last-child {
   margin-right: 0;
   }
  
    nav ul li a,nav ul li button {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
   transition: text-shadow 0.3s ease;
    }


  #f1{
  text-align: center;
  
  
  
  }
    
  nav ul li a:hover {
     color: pink;
    text-shadow: 1px 1px 2px pink, 0 0 1em pink, 0 0 0.2em white;
    animation: electric 0.8s infinite;
    }
  
  footer {
  position: flex;
  
  height: 60px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 18px;
  padding-top: 20px;
  }
  
  
  @keyframes electric {
  0% {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
  50% {
  text-shadow: 2px 2px 8px white, 0 0 20px pink;
  }
  100% {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
  }
  
  
  }
     
  
  nav ul li a:hover,nav ul li button:hover {
    color: pink;
    text-shadow: 1px 1px 2px pink, 0 0 1em pink, 0 0 0.2em white;
    animation: electric 0.8s infinite;
    }
  
  footer {
  position: flex;
  
  height: 60px;
  background-color: #333;
  color: #fff;
  text-align: center;
  font-size: 18px;
  padding-top: 20px;
  }
  
  
  @keyframes electric {
  0% {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
  50% {
  text-shadow: 2px 2px 8px white, 0 0 20px pink;
  }
  100% {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
  }
  `;

export default PracticeFormStyle;